import arrowRight from "./image/arrow-right.svg";
import styles from "./NotFoundPage.module.scss";
import {useNavigate} from "react-router-dom";
import {Header} from "../../components/Header";
import Footer from "../../components/Footer/Footer";
import {useIsMobile} from "../../hooks/useIsMobile";

export const NotFoundPage = () => {
    const navigate = useNavigate();
    const isMobile = useIsMobile()

    return (<>
            {isMobile ? null : <Header/>}
            <main>
                <div className={styles.notFoundPage}>
                    <h3 className={styles.textError}>404</h3>
                    <h1 className={styles.textQuestion}>Вы хотели пойти куда-то еще?</h1>
                    <div className={styles.notFoundAndBtnWrapper}>
                        <h2 className={styles.textNotFound}>Страница не существует</h2>
                        <button className={styles.btnNormal}
                                onClick={() => navigate("/")}>
                            <span>К афише событий</span>
                            <img src={arrowRight}
                                 alt="Стрелка вправо"/>
                        </button>
                    </div>
                </div>
            </main>
            {!isMobile && <Footer/>}
        </>
    )
}